import type { CurrentCulture } from './../types'

const allowedCultures = ['fr-FR', 'en-GB']
const defaultCulture = {
  cultureCode: 'en-GB',
  cultureShortCode: 'en',
}

/**
 * Gets the current culture. Supports 'fr-FR' and 'en-GB' cultures.
 * All other cultures will fallback to the default 'en-GB'.
 * @returns {CurrentCulture} current culture object.
 */
export function getCurrentCulture(
  filterAllowed: boolean = true
): CurrentCulture {
  const htmlRoot = document.querySelector('html') as HTMLHtmlElement

  if (!htmlRoot) {
    return defaultCulture
  }

  const cultureCode: string | undefined = htmlRoot?.dataset?.culture
  const cultureShortCode: string | null = htmlRoot?.getAttribute('lang')

  if (!cultureCode || !cultureShortCode) {
    return defaultCulture
  }

  if (filterAllowed && !allowedCultures.includes(cultureCode)) {
    return defaultCulture
  }

  return {
    cultureCode,
    cultureShortCode,
  }
}
